import React, { useState, useEffect } from "react";
import Select from "react-select";
import { horseFilter } from "store/horseFilter";

import CloseIcon from "images/close-black.png";

import "./index.scss";

const lineStyle = "w-px bg-gray-300 mx-7 md:mx-3 sm:hidden";

const Filter = () => {
  const [filterValue, setFilterValue] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({});

  const { currentFilter, filters, clearFilters, switchFilters } = horseFilter();

  const onFilterChange = (title, value, label) => {
    setFilterValue({
      ...filterValue,
      [title.toLowerCase()]: value || "",
    });

    setSelectedFilters({
      ...selectedFilters,
      [title]: {
        label,
        value,
      },
    });
  };

  const onClear = () => {
    setFilterValue({});

    setSelectedFilters(
      filters.reduce((obj, { title }) => ({ ...obj, [title]: null }), {})
    );

    clearFilters();
  };

  useEffect(() => {
    setSelectedFilters(
      filters.reduce((obj, { title }) => ({ ...obj, [title]: null }), {})
    );
  }, [filters]);

  return (
    <>
      {filters.length > 0 && (
        <div className="flex items-center justify-center filter-horses">
          <div className="bg-white py-3 px-7 sm:px-5 rounded-3xl my-6 inline-flex lmd:flex-col items-center md:gap-5 sm:gap-5 gap-11 mx-auto border border-gray-100 sm:w-full">
            <div className="flex h-full sm:justify-center sm:gap-10 xsm:gap-3 sm:max-w-full xsm:w-full">
              {filters &&
                filters.map(({ title, options }, index) => (
                  <>
                    <div
                      className={`pt-1 px-2 sm:px-0 ${
                        index == 1
                          ? "w-48 sm:w-auto xsm:flex-1"
                          : "w-32 sm:w-auto xsm:flex-1"
                      }`}
                    >
                      <h3 className="font-sans text-sm text-gray-600 mb-3">
                        {title}
                      </h3>
                      <Select
                        options={options.map(({ title, value }) => ({
                          label: title,
                          value,
                        }))}
                        value={selectedFilters[title]}
                        isSearchable={false}
                        classNamePrefix="react-select-filter"
                        onChange={({ value, label }) =>
                          onFilterChange(title, value, label)
                        }
                      />
                    </div>
                    {filters.length != index + 1 && (
                      <span className={lineStyle} />
                    )}
                  </>
                ))}
            </div>
            <div className="flex items-center justify-center gap-5 lmd:flex-col">
              <button
                className="py-3 px-12 paragraph-lg-bold text-gray-100 bg-yellow-400 rounded sm:w-full"
                onClick={() => {
                  switchFilters(filterValue);
                }}
              >
                Search
              </button>

              {currentFilter && (
                <button
                  className="flex items-center gap-1 font-sans font-bold text-sm text-indigo-700"
                  onClick={onClear}
                >
                  <img src={CloseIcon} alt="close icon" className="w-5 h-5" />
                  Clear filter
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Filter;
